import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';
import type { Comic } from '@/types';

function UpdateItem({ comic, index }: { comic: Comic; index: number }) {
  const statusLabel = comic.status === 'ongoing' ? '连载中' : '已完结';

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group flex items-center gap-4 p-3 md:p-4 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300 transition-all cursor-pointer"
    >
      <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 font-heading font-bold text-sm md:text-base">
        {index < 10 ? `0${index}` : index}
      </div>
      <div className="relative flex-shrink-0 w-14 h-20 md:w-16 md:h-24 rounded-md overflow-hidden">
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 最新更新`}
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-1 mb-1">{comic.author}</p>
        <div className="flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-booklet-line"></i>
            {comic.chapters}话
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {(comic.views / 10000).toFixed(0)}万
          </span>
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            comic.status === 'ongoing' ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-700'
          }`}>
            {statusLabel}
          </span>
        </div>
      </div>
      <div className="hidden md:flex flex-col items-end gap-1">
        <span className="text-xs text-foreground-400 whitespace-nowrap">更新于</span>
        <span className="text-xs font-medium text-foreground-600 whitespace-nowrap">{comic.updateDate}</span>
      </div>
      <div className="hidden md:flex w-8 h-8 items-center justify-center rounded-full bg-background-100 text-foreground-400 group-hover:bg-primary-50 group-hover:text-primary-500 transition-colors">
        <i className="ri-arrow-right-s-line"></i>
      </div>
    </Link>
  );
}

export default function LatestUpdate() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">最新更新</h2>
            <p className="text-sm text-foreground-500">每日同步更新，追更不迷路</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="space-y-3 md:space-y-4" data-product-shop="">
          {latestUpdates.slice(0, 8).map((comic, i) => (
            <UpdateItem key={comic.id} comic={comic} index={i + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}